import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Grid, IconButton, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import React, { useRef } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";


interface IAddProps {
  arrayGalerieToEdit: any;
  setArrayGalerieToEdit: (x: any) => void
}


const EditGalerie = (props: IAddProps) => {

  //props
  const {
    arrayGalerieToEdit,
    setArrayGalerieToEdit
  } = props


  //hooks
  const selectGaleriePhoto: any = useRef(null);
  const [loadingSelectGaleriePhoto, setLoadingSelectGaleriePhoto] = React.useState<boolean>(false);



  /**
   * cette fonction permet de charger une ou plusieurs images de la galérie
   *  puis les transforme en base 64
   * @param event 
   */
  const handleAddGaleriePhotosBase64 = (event: any) => {
    setLoadingSelectGaleriePhoto(true)
    const fileList = event.target.files;
    const fileObjects: any = Array.from(fileList).map((file: any) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Lit le fichier en tant que DataURL
      // Crée une promesse pour attendre la fin de la lecture du fichier
      return new Promise((resolve) => {
        reader.onloadend = () => {
          resolve({
            name: file.name,
            size: file.size,
            type: file.type,
            lastModified: file.lastModified,
            url: reader.result, // Récupère le résultat en tant que DataURL
          });
        };
      });
    });
    // Attend que toutes les promesses soient résolues
    Promise.all(fileObjects).then((results) => {
      setArrayGalerieToEdit([...arrayGalerieToEdit, ...results]);
      setLoadingSelectGaleriePhoto(false)
    });
  };


  /**
   * Permet de supprimer une image du tableau local.
   * @param currentIndex 
   */
  const handlePhotoDelete = (currentIndex: number) => {
    let newData = [...arrayGalerieToEdit]
    const res = newData.filter((item, index) => index !== currentIndex)
    setArrayGalerieToEdit(res)
  };


  /**
 *  cette fonction permet de repositionner les images
 * @param result (draggableId, source, destination)
 * (draggableId:l'identifiant de l'image à deplacer)
 * (source:la position de depart de l'image à deplacer)
 * (destination:la position d'arriver de l'image à deplacer)
 * @returns
 *
 */
  const onDragEnd = (result: any) => {
    const { draggableId, source, destination } = result;
    const parseIntdraggableId = parseInt(draggableId);
    //Ne rien executer si on deplace un item hors de la carde
    if (!destination) {
      return;
    }
    //Ne rien executer si l'on bouge un item et qu'on le remet à sa place
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    //obtenir l'objet à repositionnner
    const sectionARepositionner: any = arrayGalerieToEdit?.find(
      (section: any, index: number) => index === parseIntdraggableId
    );
    //remplacer les places dans le tableau
    let newPhotoGalerie = [...arrayGalerieToEdit];
    newPhotoGalerie.splice(source.index, 1);
    newPhotoGalerie.splice(destination.index, 0, sectionARepositionner);

    //mise à jour du state
    setArrayGalerieToEdit(newPhotoGalerie);
    return;
  };



  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid item md={12} xs={12} sm={12}>
        <Grid
          container
          spacing={2}
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >

          <Grid item md={4} xs={12} sm={4}>
            <Tooltip title="Charger les images de la galérie">
              <Button
                variant="outlined"
                color="primary"
                component="label"
                startIcon={<ArtTrackIcon />}
                style={{ marginTop: 10 }}
                onClick={() => {
                  selectGaleriePhoto?.current?.click();
                }}
              >
                Ajouter des images
              </Button>
            </Tooltip>
            <input
              hidden
              multiple
              type="file"
              name="galeriePhoto"
              ref={selectGaleriePhoto}
              onChange={handleAddGaleriePhotosBase64}
            />
          </Grid>

          <Grid item md={8} xs={12} sm={8}>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable" direction="vertical">
                {(provider: any) => (
                  <div
                    style={{
                      background: "aliceblue",
                      padding: 10,
                      height: "57vh",
                      overflow: "auto",
                    }}
                    ref={provider.innerRef}
                    {...provider.droppableProps}
                  >
                    <Box sx={{ flexGrow: 1, width: "100%" }}>
                      <List dense={true}>
                        <Grid
                          container
                          spacing={2}
                          direction="row"
                          justifyContent="flex-start"
                        >
                          {arrayGalerieToEdit.length > 0 &&
                            arrayGalerieToEdit.map((item: any, i: number) => {
                              const newIndex = i.toString();
                              return (
                                <div key={i}>
                                  <Draggable draggableId={newIndex} index={i}>
                                    {(provider: any, snapshot: any) => (
                                      <div
                                        ref={provider.innerRef}
                                        {...provider.draggableProps}
                                        {...provider.dragHandleProps}
                                      >
                                        <ListItem
                                          secondaryAction={
                                            <IconButton
                                              onClick={() =>
                                                handlePhotoDelete(i)
                                              }
                                            >
                                              <DeleteIcon fontSize="small" />
                                            </IconButton>
                                          }
                                        >
                                          <img src={item.url} alt={item.name} style={{ width: "20%", height: "20%" }} />
                                        </ListItem>
                                        <Divider />
                                        {provider.placeholder}
                                      </div>
                                    )}
                                  </Draggable>
                                </div>
                              );
                            })}
                          {loadingSelectGaleriePhoto && "Veuillez patienter svp..."}
                        </Grid>
                      </List>
                    </Box>
                    {provider.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EditGalerie;